import { render, staticRenderFns } from "./ListWishes.vue?vue&type=template&id=2f0dc51a&scoped=true&"
import script from "./ListWishes.vue?vue&type=script&lang=js&"
export * from "./ListWishes.vue?vue&type=script&lang=js&"
import style0 from "./ListWishes.vue?vue&type=style&index=0&id=2f0dc51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0dc51a",
  null
  
)

export default component.exports